import { DownloadCTA } from "@/components/landing/DownloadCTA";
import { PageFooterNav } from "@/components/landing/PageChrome";
import { SEO } from "@/components/SEO";

export default function PageDownload() {
  return (
    <>
      <SEO
        title="Télécharger l'application Zafara"
        description="Téléchargez Zafara sur l'App Store et Google Play. La marketplace 100% béninoise, gratuite, avec paiement Mobile Money."
        path="/telecharger"
      />
      <DownloadCTA />
      <PageFooterNav
        prev={{ to: "/contact", label: "Contact" }}
        next={{ to: "/pourquoi-zafara", label: "Pourquoi Zafara" }}
      />
    </>
  );
}
